
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff } from "lucide-react";

interface PasswordFieldsProps {
  newPassword: string;
  confirmPassword: string;
  setNewPassword: (value: string) => void;
  setConfirmPassword: (value: string) => void;
  passwordsMatch: boolean;
  passwordMeetsRequirements: boolean;
}

export const PasswordFields = ({
  newPassword,
  confirmPassword,
  setNewPassword,
  setConfirmPassword,
  passwordsMatch,
  passwordMeetsRequirements,
}: PasswordFieldsProps) => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="newPassword">Nova senha</Label>
        <div className="relative">
          <Input 
            id="newPassword" 
            type={showNewPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className={!passwordMeetsRequirements && newPassword ? "border-red-500 focus:ring-red-500" : ""}
          />
          <button 
            type="button"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
            onClick={() => setShowNewPassword(!showNewPassword)}
          >
            {showNewPassword ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
        {!passwordMeetsRequirements && newPassword && (
          <p className="text-xs text-red-500">A senha deve ter pelo menos 6 caracteres</p>
        )}
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="confirmPassword">Confirmar nova senha</Label>
        <div className="relative">
          <Input 
            id="confirmPassword" 
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className={!passwordsMatch && confirmPassword ? "border-red-500 focus:ring-red-500" : ""}
          />
          <button 
            type="button"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
        {!passwordsMatch && confirmPassword && (
          <p className="text-xs text-red-500">As senhas não coincidem</p>
        )}
      </div>
    </>
  );
};
